import { Fragment, useContext } from "react";
import { AccountContext } from "contexts";
import { useFormContext, useWatch } from "react-hook-form";
import { convertNumber, useCoaByCode } from "utils";
import { PaymentBillServiceSchema } from "../schema";

export const JournalListOnPrint = () => {
  return <></>;
}

const PaymentAccount = () => {
  const account = useContext(AccountContext);
  const tracking = useCoaByCode("LA07");

  const { control } = useFormContext<PaymentBillServiceSchema>();
  const coa_id = useWatch({ control, name: "coa_id" });
  const payment_amount = useWatch({ control, name: "payment_amount" });

  const coa = account.data?.find((item) => item.value === coa_id)?.label ?? "-";
  const formattedAmount = convertNumber(payment_amount).intoCurrency;

  if (coa_id && payment_amount) {
    return (
      <Fragment>
        <tr>
          <td>{tracking.data}</td>
          <td className="text-right">{formattedAmount}</td>
          <td className="text-right"></td>
        </tr>

        <tr>
          <td>{coa}</td>
          <td className="text-right"></td>
          <td className="text-right text-error">{formattedAmount}</td>
        </tr>
      </Fragment>
    );
  }

  return <Fragment />;
}

const PaymentDeposit = () => {
  const tracking = useCoaByCode("LA07");
  const asset = useCoaByCode("LA09");

  const { control } = useFormContext<PaymentBillServiceSchema>();
  const deposit_amount = useWatch({ control, name: "deposit_amount" });

  const formattedAmount = convertNumber(deposit_amount).intoCurrency;

  if (deposit_amount) {
    return (
      <Fragment>
        <tr>
          <td>{tracking.data}</td>
          <td className="text-right">{formattedAmount}</td>
          <td className="text-right"></td>
        </tr>

        <tr>
          <td>{asset.data}</td>
          <td className="text-right"></td>
          <td className="text-right text-error">{formattedAmount}</td>
        </tr>
      </Fragment>
    );
  }

  return <Fragment />;
}

JournalListOnPrint.PaymentAccount = PaymentAccount;
JournalListOnPrint.PaymentDeposit = PaymentDeposit;
